import apiClient from "./apiClient";

// Users
export const getUsers = (params) => apiClient.get("/api/users", { params });
export const getUser = (id) => apiClient.get(`/api/users/${id}`);
export const createUser = (data) => apiClient.post("/api/users", data);
export const updateUser = (id, data) => apiClient.put(`/api/users/${id}`, data);
export const deleteUser = (id) => apiClient.delete(`/api/users/${id}`);
export const resetUserPassword = (id, data) => apiClient.post(`/api/users/${id}/reset-password`, data);

// Roles
export const getRoles = () => apiClient.get("/api/roles");
export const createRole = (data) => apiClient.post("/api/roles", data);
export const updateRole = (id, data) => apiClient.put(`/api/roles/${id}`, data);
export const deleteRole = (id) => apiClient.delete(`/api/roles/${id}`);

// Role Permissions
export const getRolePermissions = (roleId) => apiClient.get(`/api/roles/${roleId}/permissions`);
export const updateRolePermissions = (roleId, permissions) =>
  apiClient.put(`/api/roles/${roleId}/permissions`, { permissions });

// Audit Log
export const getAuditLog = (params) => apiClient.get("/api/audit-log", { params });

// Clinic Settings
export const getSettings = () => apiClient.get("/api/settings");
export const updateSettings = (data) => apiClient.put("/api/settings", data);
